export default "__VITE_ASSET__69f28739__"